import React from "react";
import { Button, Form, Alert, Typography, Icon, Modal, Input } from "antd";
// import findInstagramUrl1 from "../assets/findInstagramUrl1.png";
// import findInstagramUrl2 from "../assets/findInstagramUrl2.png";

const FormItem = Form.Item;
const { Title } = Typography;

function PaypalForm(props) {
  return (
    <div>
      <Title level={4} style={styles.heading}>
        Submit your Paypal email to receive your rebate!
        <FormItem
          //   extra={
          //     <a onClick={postUrlHelpModal}>
          //       How do I find my Instagram post link?
          //       {"\u00A0"}
          //       <Icon type="info-circle" theme="outlined" />
          //     </a>
          //   }
          validateStatus={props.invalidPaypal}
          help={
            props.invalidPaypal == "error"
              ? props.invalidPaypalMessage || "Invalid email format"
              : null
          } //show if invalid
        >
          <Input
            name="paypalEmail"
            placeholder={"susan.smith@gmail.com"}
            onChange={props.handleInputChange}
            value={props.paypalEmail}
          />
        </FormItem>
        <Button onClick={props.submitPaypal} size="large" type="primary">
          Submit
        </Button>
      </Title>
    </div>
  );
}

// const postUrlHelpModal = () => {
//   //renders modal on " How do I find my Instagram Post URL?" click
//   Modal.info({
//     icon: "no icon",
//     title: "How to find an Instagram post URL",
//     maskClosable: true,
//     content: (
//       <div style={{ overflowY: "auto" }}>
//         <img
//           style={{ width: "100%", marginBottom: "5%" }}
//           src={findInstagramUrl1}
//         />
//         <img style={{ width: "100%" }} src={findInstagramUrl2} />
//       </div>
//     ),
//     onOk() {}
//   });
// };

const styles = {
  heading: { fontWeight: "300" }
};

export default PaypalForm;
